import Cookies from "js-cookie";
import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { GetErrorPageUrl } from "../../actions/GetErrorPageUrl";
import { Loading } from "../../components";
import Checkbox from "../../components/Checkbox";
import UserCard from "../../components/UserCard/UserCard";
import Config from "../../config";
import { AuthContext } from "../../contexts/AuthContext";
import { ThemeContext } from "../../contexts/ThemeContext";
import { sendEvent } from "../../hooks/analytics";
import {
  AssociateRequest,
  useAssociate,
  useAssociationValidate,
  useCheckTermsOfUse
} from "../../hooks/be";
import { ErrorResponse } from "../../hooks/errorReponse";
import { useQueryParams } from "../../hooks/queryParams";
import { ErrorType } from "../Error/errorType";
import {
  Button,
  Container,
  ContainerCheckBox,
  ContainerTerms,
  LinkTerms,
  TermsText,
  TitleText
} from "./styles";

export const TermsOfUse = () => {
  const { user, authenticate } = useContext(AuthContext);
  useEffect(() => {
    authenticate();
  }, []);

  const { setHeaderReturn, setHeaderUser } = useContext(ThemeContext);
  const serviceId = localStorage.getItem("serviceId") || "";
  const providerName = localStorage.getItem("providerName") || "";
  const termsLink = Config.TERMS_OF_USE_URL + serviceId;
  const privacyPolicyLink = Config.PRIVACY_POLICY_URL;
  setHeaderReturn(false);
  setHeaderUser(false);

  const queryParams = useQueryParams();
  const hasResource = queryParams.get("hasResource") || "";
  const [errorAPI] = useState<boolean>(false);
  const [mustAcceptTerms, setMustAcceptTerms] = useState<boolean>(true);
  const [checked, setChecked] = useState<boolean>(false);
  const [errorCode] = useState<string>("");
  const [errorId] = useState<string>("");
  const [email] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [termsCalled, setTermsCalled] = useState<boolean>(false);
  const [isValidAssociation, setIsValidAssociation] = useState<boolean>(false);

  const [responseError, setResponseError] = useState<ErrorResponse>();

  const userData: AssociateRequest = {
    glbid: Cookies.get("GLBID") || "",
    userId: localStorage.getItem("userId") || "",
    providerId: localStorage.getItem("providerId") || "",
    state: localStorage.getItem("state") || "",
    serviceId: parseInt(localStorage.getItem("serviceId") || "0")
  };
  const globoId = localStorage.getItem("globoId") || "";

  const { associate } = useAssociate(userData);
  const { checkTerms } = useCheckTermsOfUse(serviceId);
  const { associationValidate } = useAssociationValidate(userData);

  const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  useEffect(() => {
    sendEvent(
      "alf_page_view",
      {
        user_code_provider_hit: "cadun",
        page_name_custom: "termos_de_uso",
        provider_name: providerName
      },
      { user_code: globoId, user_code_provider: "cadun" }
    );

    if (hasResource !== "false") {
      associationValidate()
        .then(data => {
          setIsValidAssociation(data);
        })
        .catch((error: ErrorResponse) => {
          setResponseError(error);
        });
    } else {
      setIsValidAssociation(true);
    }
  }, [associationValidate, globoId, providerName, hasResource]);

  useEffect(() => {
    if (!isValidAssociation || !serviceId) {
      return;
    }

    checkTerms()
      .then(data => {
        setMustAcceptTerms(data.mustAcceptTerms);
        setTermsCalled(true);
      })
      .catch((error: ErrorResponse) => {
        setResponseError(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [isValidAssociation, serviceId, checkTerms]);

  useEffect(() => {
    if (errorAPI) {
      let redirect = `/error?error_code=${errorCode}&error_id=${errorId}`;
      if (errorCode === ErrorType.AnotherAccountGlobo) {
        redirect = `/error?error_code=${errorCode}&email=${email}&error_id=${errorId}`;
      }
      window.location.href = redirect;
    }
  }, [errorAPI, errorCode, email]);

  const associateUser = () => {
    setIsLoading(true);

    associate()
      .then(() => {
        setMustAcceptTerms(false);
        window.location.href = "/success";
      })
      .catch((error: ErrorResponse) => {
        setResponseError(error);
      })
      .finally(() => {
        setIsLoading(false);
      });

    sendEvent(
      "component_click",
      {
        component_name: "concluir",
        component_type: "button",
        component_item_link_redirect: window.location.href,
        page_name_custom: "termos_de_uso",
        provider_name: providerName
      },
      {
        user_code: globoId,
        user_code_provider: "cadun"
      }
    );
  };

  useEffect(() => {
    if (!errorAPI && !mustAcceptTerms && termsCalled) {
      associateUser();
    }
  }, [errorAPI, mustAcceptTerms, termsCalled]);

  if (responseError) {
    return <Navigate to={GetErrorPageUrl(responseError)} />;
  }

  if (isLoading) {
    return <Loading />;
  }

  if (mustAcceptTerms) {
    return (
      <ContainerTerms>
        <Container>
          {user && <UserCard user={user} />}
          <TitleText>Termos de uso</TitleText>
          <TermsText>
            Para prosseguir, precisamos que você de acordo com os nossos Termos
            de Uso e Política de privacidade.
          </TermsText>
          <ContainerCheckBox>
            <Checkbox checked={checked} toggle={handleCheckboxChange}>
              Li e concordo com os{" "}
              <LinkTerms href={termsLink} target="_blank">
                Termos de Uso
              </LinkTerms>{" "}
              e a{" "}
              <LinkTerms href={privacyPolicyLink} target="_blank">
                Política de Privacidade.
              </LinkTerms>
            </Checkbox>
          </ContainerCheckBox>
          <Button disabled={!checked} onClick={associateUser}>
            Concluir
          </Button>
        </Container>
      </ContainerTerms>
    );
  }

  return <Loading />;
};

export default TermsOfUse;
